import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Docs from './views/Docs.vue'
import API from './views/API.vue'
import PageNotFound from './views/404.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { transition: 'fade' }
    },
    {
      path: '/docs',
      name: 'docs',
      component: Docs,
      meta: { transition: 'fade' }
    },
    {
      path: '/api',
      name: 'api',
      component: API,
      meta: { transition: 'fade' }
    },
    {
      path: '*',
      name: '404',
      component: PageNotFound,
      meta: { transition: 'fade' }
    }
  ]
})
